export default __webpack_public_path__ + "static/media/480_store01-nl-web.520d346f.png";